import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'attributeCategory',
    serviceName: 'shopadmin',
    query: gql`
      query attributeCategory($ids: [String]) {
        attributeCategory(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
